module.exports = __webpack_public_path__ + "media/icons/down-arrow-active-64e8965d.png";